@if (layersVisible) {
<div id="draggable" class="wrapper-draggable-window" cdkDrag cdkDragBoundary=".content"
	[cdkDragFreeDragPosition]="dragPosition" [class.minimize]="isMinimized">
	<div id="draggableheader" class="header" cdkDragHandle>
		<h4>{{ labels().LAYERS_COMPONENT_HEADER }}</h4>
		<!--NOTA: cliccando l'icona "reduce-expand" bisogna aggiungere la classe "minimize" a "wrapper-draggable-window" -->
		<i class="material-icons md-18 reduce-expand" (click)="toggle()" (keypress)="toggle()">minimize</i>
	</div>
	<div class="content-layers" [hidden]="isMinimized">

		<!--Labels-->
		<div class="row-layer">
			<span style="color: #FFFFFF; font-weight: bold;">{{ labels().LAYERS_COMPONENT_LABELS }}</span>
			<div class="wrapper-icons-actions">
				<i class="material-icons md-18" (click)="resetLB()" (keypress)="resetLB()">sync</i>
				@if (!layersValue?.labels) {
				<i class="material-icons-outlined md-18" (click)="setVisibilityLB(true)"
					(keypress)="setVisibilityLB(true)">visibility_off</i>
				} @else {
				<i class="material-icons md-18" (click)="setVisibilityLB(false)"
					(keypress)="setVisibilityLB(false)">visibility</i>
				}
			</div>
		</div>

		<!--Mechanical Axis-->
		@if (layers?.mechanicalAxis_mechanical) {
		<div class="row-layer">
			<span style="color: #0C64C0; font-weight: bold;">{{ labels().LAYERS_COMPONENT_MECHANICAL_AXIS }}</span>
			<div class="wrapper-icons-actions">
				@if (!layersValue?.mechanicalAxis_mechanical) {
				<i class="material-icons-outlined md-18" (click)="setVisibilityMA(true)"
					(keypress)="setVisibilityMA(true)">visibility_off</i>
				} @else {
				<i class="material-icons md-18" (click)="setVisibilityMA(false)"
					(keypress)="setVisibilityMA(false)">visibility</i>
				}
			</div>
		</div>
		}

		<!--Mechanical Anatomical Axis-->
		@if (layers?.mechanicalAxis_anatomical) {
		<div class="row-layer">
			<span style="color: #ED7D31; font-weight: bold;">{{ labels().LAYERS_COMPONENT_MNSA_TOOL }}</span>
			<div class="wrapper-icons-actions">
				@if (!layersValue?.mechanicalAxis_anatomical) {
				<i class="material-icons-outlined md-18" (click)="setVisibilityMNSA(true)"
					(keypress)="setVisibilityMNSA(true)">visibility_off</i>
				} @else {
				<i class="material-icons md-18" (click)="setVisibilityMNSA(false)"
					(keypress)="setVisibilityMNSA(false)">visibility</i>
				}
			</div>
		</div>
		}

		<!--Weightbearing-->
		@if (layers?.mechanicalAxis_weightBearing) {
		<div class="row-layer">
			<span style="color: #00FF00; font-weight: bold;">{{ labels().LAYERS_COMPONENT_WEIGHTBEARING }}</span>
			<div class="wrapper-icons-actions">
				@if (!layersValue?.mechanicalAxis_weightBearing) {
				<i class="material-icons-outlined md-18" (click)="setVisibilityWB(true)"
					(keypress)="setVisibilityWB(true)">visibility_off</i>
				} @else {
				<i class="material-icons md-18" (click)="setVisibilityWB(false)"
					(keypress)="setVisibilityWB(false)">visibility</i>
				}
			</div>
		</div>
		}

		<!--Contralateral-->
		@if (layers?.contralateral_all) {
		<div class="row-layer">
			<span style="color: deepskyblue; font-weight: bold;">{{ labels().LAYERS_COMPONENT_CONTRALATERAL }}</span>
			<div class="wrapper-icons-actions">
				@if (!layersValue?.contralateral_all) {
				<i class="material-icons-outlined md-18" (click)="setVisibilityCL(true)"
					(keypress)="setVisibilityCL(true)">visibility_off</i>
				} @else {
				<i class="material-icons md-18" (click)="setVisibilityCL(false)"
					(keypress)="setVisibilityCL(false)">visibility</i>
				}
			</div>
		</div>
		}

		<!--Osteotomy-->
		@if (layers?.osteotomy) {
		<div class="row-layer">
			<span style="color: #FF0000; font-weight: bold;">{{ labels().LAYERS_COMPONENT_OSTEOTOMY }}</span>
			<div class="wrapper-icons-actions">
				@if (!layersValue?.osteotomy) {
				<i class="material-icons-outlined md-18" (click)="setVisibilityOS(true)"
					(keypress)="setVisibilityOS(true)">visibility_off</i>
				} @else {
				<i class="material-icons md-18" (click)="setVisibilityOS(false)"
					(keypress)="setVisibilityOS(false)">visibility</i>
				}
			</div>
		</div>
		}

		<!--Lines-->
		@if (layers?.lines) {
		<div class="row-layer">
			<span style="color: #EC44CC; font-weight: bold;">{{ labels().LAYERS_COMPONENT_LINE }}</span>
			<div class="wrapper-icons-actions">
				@if (!layersValue?.lines) {
				<i class="material-icons-outlined md-18" (click)="setVisibilityLN(true)"
					(keypress)="setVisibilityLN(true)">visibility_off</i>
				} @else {
				<i class="material-icons md-18" (click)="setVisibilityLN(false)"
					(keypress)="setVisibilityLN(false)">visibility</i>
				}
			</div>
		</div>
		}

		<!--Goniometers-->
		@if (layers?.goniometers) {
		<div class="row-layer">
			<span style="color: #EC44CC; font-weight: bold;">{{ labels().LAYERS_COMPONENT_GONIOMETER }}</span>
			<div class="wrapper-icons-actions">
				@if (!layersValue?.goniometers) {
				<i class="material-icons-outlined md-18" (click)="setVisibilityGM(true)"
					(keypress)="setVisibilityGM(true)">visibility_off</i>
				} @else {
				<i class="material-icons md-18" (click)="setVisibilityGM(false)"
					(keypress)="setVisibilityGM(false)">visibility</i>
				}
			</div>
		</div>
		}

		<!--Plate-->
		@if (layers?.plate) {
		<div class="row-layer">
			<span style="color: lightgrey; font-weight: bold;">{{ labels().LAYERS_COMPONENT_PLATE }}</span>
			<div class="wrapper-icons-actions">
				@if (!layersValue?.plate) {
				<i class="material-icons-outlined md-18" (click)="setVisibilityPL(true)"
					(keypress)="setVisibilityPL(true)">visibility_off</i>
				} @else {
				<i class="material-icons md-18" (click)="setVisibilityPL(false)"
					(keypress)="setVisibilityPL(false)">visibility</i>
				}
			</div>
		</div>
		}
	</div>

</div>
}